import { Outlet } from 'react-router-dom';

import { InstallPrompt } from './InstallPrompt';

/**
 * Outer shell rendered around every route. Hosts cross-route widgets like
 * the PWA `<InstallPrompt />` that need router context (for path detection)
 * but should live outside the chrome-bearing `<Layout>` shell.
 *
 * Keep this dumb — anything more substantial should be a feature-level
 * component, not part of the routing scaffold.
 */
export function AppShell() {
  return (
    <>
      <Outlet />
      <InstallPrompt />
    </>
  );
}
